import React from "react";
import { Card } from "../atoms";
import styled, { keyframes } from "styled-components";
import { theme } from "../theme/semanticTheme";
import { Autorenew } from "@mui/icons-material";

const variantBorderColor = {
  success: theme.colors.success,
  error: theme.colors.error,
  warning: theme.colors.warning,
  accent: theme.colors.accent,
  neutral: theme.colors.textMuted,
};

const Wrapper = styled(Card)`
  padding: ${theme.spacing.lg};
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 4px solid ${(p) => variantBorderColor[p.$pillVariant] ?? theme.colors.border};
`;

const Label = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${(p) => (p.$color ? p.$color : theme.colors.textMuted)};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  margin-bottom: ${theme.spacing.sm};
`;

const LabelIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: ${theme.colors.backgroundAlt};
  color: inherit;
  font-size: 10px;
  flex-shrink: 0;
`;

const Value = styled.span`
  font-size: 24px;
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.sm};
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoadingIcon = styled(Autorenew)`
  animation: ${spin} 1s linear infinite;
  font-size: 1.6rem;
  color: ${theme.colors.primary};
`;

/**
 * Molecule: MetricCard – heading from pillLabel, large value, colored top border by pillVariant.
 * When loading is true, shows a simple inline loader instead of the value.
 */
export default function MetricCard({ label, value, pillLabel, pillVariant = "neutral", loading = false, icon }) {
  const borderColor = variantBorderColor[pillVariant] ?? theme.colors.textMuted;
  const heading = pillLabel ?? label;
  return (
    <Wrapper $pillVariant={pillVariant}>
      <Label $color={borderColor}>
        {icon && <LabelIcon>{icon}</LabelIcon>}
        {heading}
      </Label>
      <Value>{loading ? <LoadingIcon /> : (value ?? "–")}</Value>
    </Wrapper>
  );
}
